import {
    GET_ERRORS, SUCCESS_ALERT
} from './type';
import Products from '../Models/Products';

export const sellerRequest = (sellerData, history) => dispatch => {
    // let i=[];
    Products.saveRequest(sellerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                // alert('Thank for your request! You will be notified when you have a suggestion.')
                // history.push('/seller-buyer-request-home');
                history.push({
                    pathname: '/seller-buyer-request-home',
                    state: { flag: SUCCESS_ALERT }
                });
            }
            else {
                dispatch({
                    type: GET_ERRORS,
                    payload: 'No data available! Please try again later.'
                })
            }

        })
        .catch()
};
